// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-request-list-card-header[data-v-4859a993]{display:flex}.member-request-list-card-header strong[data-v-4859a993]{flex-grow:1}`, "",{"version":3,"sources":["<input css 16>"],"names":[],"mappings":"AAAA,kDAAiC,YAAY,CAAC,yDAAwC,WAAW","sourcesContent":[".member-request-list-card-header{display:flex}.member-request-list-card-header strong{flex-grow:1}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
